import {apolloClient} from "../../plugins/apollo-client";
import CREATE_NOTE from '../../graphql/notes/create.gql';
import UPDATE_NOTE from '../../graphql/notes/update.gql';
import DELETE_NOTE from '../../graphql/notes/delete.gql';

const saveNote = (callSid, note) =>
  apolloClient
    .mutate({
      mutation: CREATE_NOTE,
      variables: {
        callSid,
        note
      }
    }).then(({data: {note}}) => note);

const updateNote = (callSid, note) =>
  apolloClient
    .mutate({
      mutation: UPDATE_NOTE,
      variables: {
        callSid,
        note
      }
    }).then(({data: {note}}) => note);

const deleteNote = (id) =>
  apolloClient
    .mutate({
      mutation: DELETE_NOTE,
      variables: {
        id
      }
    }).then(({data: {note}}) => note);

export {
  saveNote,
  deleteNote,
  updateNote
}
